module.exports = __webpack_public_path__ + "assets/images/rbyearend-19.jpg?v=b7470cf9";